"use client";
import React, { Dispatch, SetStateAction, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { CompanyLogo, Sidebar } from "../design1/NavBar";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import { Config } from "../../../../types";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import {
  FacebookIcon,
  TikTokIcon,
  TwitterIcon,
  LinkedinIcon,
  YoutubeIcon,
  InstagramIcon,
} from "../../Icon";
import { SocialMedia } from "../../../../types";
import { Address } from "../../../../types";
import Button from "../../ui/Button";
import { navLinks } from "../../constants/navlink";
import { Hamburger } from "../design1/NavBar";
import { getPageVisibilityClass } from "../design1/Footer";
export const socialMediaIcons: Record<keyof SocialMedia, React.ReactElement> = {
  facebook: <FacebookIcon />,
  instagram: <InstagramIcon />,
  linkedin: <LinkedinIcon />,
  tiktok: <TikTokIcon />,
  twitter: <TwitterIcon />,
  youtube: <YoutubeIcon />,
};
export function getSocialIcons(socialMedia: SocialMedia, variant?: boolean) {
  return Object.entries(socialMedia).map(([platform, url]) =>
    url ? (
      <Link
        className={`${
          variant &&
          "rounded-full border border-themeColor size-10 grid place-items-center"
        }`}
        key={platform}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {socialMediaIcons[platform as keyof SocialMedia]}
      </Link>
    ) : null
  );
}
export function flattenAddress(address: Address): string {
  return `${address.street}, ${address.city}, ${address.state} ${address.zipCode}, ${address.country}`;
}

const NavBar1 = () => {
  const { socialMediaLinks } = useFetchValidSocialMediaLinks();
  const { data: config } = useFetchCompanyInfo();

  const [open, setOpen] = useState(false);
  return (
    <>
      <Sidebar
        variant
        socials={socialMediaLinks}
        open={open}
        config={config}
        setOpen={setOpen}
        navLinks={navLinks}
      />
      <nav className=" shadow-lg  fixed top-0  z-[60] text-primary bg-white w-full left-0   py-3">
        <div className="wrapper flex flex-col gap-5 ">
          <div className="second flex items-center justify-between">
            <Link href="/">
              <header>
                <CompanyLogo />
              </header>
            </Link>

            <NavItems config={config as Config} />
            <div className="buttons items-center flex gap-3">
              <Button
                href="https://app.ourproperty.com.ng/auth/user/sign-in"
                className="xlg:hidden primary-btn"
              >
                Sign in
              </Button>
              <Hamburger open={open} setOpen={setOpen} />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
export default NavBar1;

export const NavItems = ({ config }: { config: Config }) => {
  const pathname = usePathname();
  // const [hovered, setHovered] = useState(false);
  const [openSub, setOpenSub] = useState(false);

  return (
    <ul className="flex xlg:hidden gap-8 items-center">
      {navLinks.map((item, index) => {
        // Updated isActive logic
        const isActive =
          pathname === item.link || // Exact match
          (item.link === "/properties" && pathname.startsWith("/properties/")); // Subpath match for /properties
        return (
          <li
            className="relative"
            onMouseEnter={() => {
              // setHovered(true);
              if (item.link === "/properties") {
                setOpenSub(true);
              }
            }}
            onMouseLeave={() => {
              // setHovered(true); // Note: This should likely be setHovered(false), see below
              if (item.link === "/properties") {
                setOpenSub(false);
              }
            }}
            key={index}
          >
            {openSub && item.link === "/properties" && (
              <HoverList setOpen={setOpenSub} />
            )}

            <Link
              className={`py-2 ${getPageVisibilityClass(
                item.link,
                config,
                "!hidden"
              )} hover:text-themeColor ${
                isActive ? "!text-themeColor" : ""
              } group relative`}
              href={item.link}
            >
              {item.name}
              <div
                className={`absolute h-[4px] ${
                  isActive ? "!bg-themeColor" : ""
                } transition-all duration-500 group-hover:bg-themeColor right-0 w-full bg-transparent bottom-0 rounded-full`}
              ></div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

interface UrlItem {
  link: string;
  name: string;
}

// Update urls to be an array of objects
const urls: UrlItem[] = [
  { link: "/properties/rent", name: "For Rent" },
  { link: "/properties/sale", name: "For Sale" },
  { link: "/properties/shortlet", name: "Shortlet" },
];
interface UrlItem {
  link: string;
  name: string;
}

const HoverLink: React.FC<{
  item: UrlItem;
  setOpen: () => void;
  variant?: boolean;
}> = ({ item, setOpen, variant }) => {
  const { data } = useFetchCompanyInfo();
  const [hovered, setHovered] = useState(false);
  const pathname = usePathname();
  const isActive = pathname.startsWith(item.link); // Supports parent & child routes
  return (
    <li onClick={setOpen}>
      <Link
        href={item.link}
        className={`relative p-3 whitespace-nowrap block ${getPageVisibilityClass(
          item.link,
          data as Config,
          "!hidden"
        )} py-2`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div
          className={`absolute bottom-0 left-1/2  -translate-x-1/2  whitespace-nowrap h-[4px]  w-[90%] ${
            variant && "!w-2 !h-2 left-1/2  -translate-x-1/2 rounded-full"
          } rounded-full transition-all duration-500 bg-transparent 
          ${isActive || hovered ? "!bg-themeColor" : ""}`}
        ></div>
        {item.name}
      </Link>
    </li>
  );
};

export const HoverList: React.FC<{
  setOpen: Dispatch<SetStateAction<boolean>>;
  variant?: boolean;
  className?: string;
}> = ({ setOpen, variant, className }) => {
  return (
    <ul
      className={`absolute  flex flex-col gap-1 text-secondary-main bg-white rounded-md top-[120%] ${className}`}
    >
      <div className="absolute w-full h-4 left-0 -top-4 bg-transparent"></div>
      {urls.map((item, index) => (
        <HoverLink
          variant={variant}
          key={index}
          item={item}
          setOpen={() => setOpen(false)}
        />
      ))}
    </ul>
  );
};
